// @flow

import React from 'react'
import styles from './WxSharePopup.scss'
import shareImg from './images/share-in-weixin.png'
import type { UiPopup } from 'redux/type/uiPopup'

export default class extends React.PureComponent<{
  uiPopup: UiPopup
}> {
  render () {
    let { onOk } = this.props.uiPopup
    return (
      <div
        onClick={onOk}
        className={`${styles.this}`}
        style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          top: 0,
          background: 'rgba(0, 0, 0, .6)',
          zIndex: 100105
        }}
      >
        <img
          src={shareImg}
          style={{ maxWidth: '375px', width: '100%', float: 'right' }}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frame/ui/popup/WxSharePopup.js